<template>
  <div>

    <div class="row mt-4">
      <div class="col-md-12">
        <input class="input form-control"
               v-model="search"
               placeholder="Pesquisar por app, nome do serviço, título ou descrição">
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-3">
        <label for="ts-app">Aplicação <span class="en-hint">(app)</span></label>
        <select v-model="filterApp" id="ts-app" class="form-control">
          <option value="">Todos</option>
          <option v-for="app in appOptions" :key="app" :value="app">{{ app }}</option>
        </select>
      </div>

      <div class="col-md-3">
        <label for="ts-status">Situação <span class="en-hint">(status)</span></label>
        <select v-model="filterStatus" id="ts-status" class="form-control">
          <option value="">Todos</option>
          <option value="active">active</option>
          <option value="in_maintenance">in_maintenance</option>
          <option value="inactive">inactive</option>
        </select>
      </div>
    </div>

    <hr>

    <div class="row">
      <div class="col-sm-12">

        <div class="row mt-2">
          <div class="col-md-12">
            <strong>{{ infoTotalModels }}</strong>
          </div>
        </div>

        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th>Aplicação <span class="en-hint">(app)</span></th>
              <th>Nome do serviço <span class="en-hint">(name)</span></th>
              <th>Título <span class="en-hint">(title)</span></th>
              <th>Descrição <span class="en-hint">(description)</span></th>
              <th>Situação <span class="en-hint">(status)</span></th>
              <th>Credenciais <span class="en-hint">(credentials)</span></th>
              <th>Rótulos <span class="en-hint">(labels)</span></th>
              <th>Detalhes</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(service, index) in filteredServices" :key="`${service.app}-${service.name}-${index}`">
              <td>{{ service.app }}</td>
              <td>{{ service.name }}</td>
              <td>{{ service.metadata && service.metadata.title }}</td>
              <td>{{ (service.metadata && service.metadata.description) || '-' }}</td>
              <td>
                <span class="status-badge" :class="statusClass(service.status)">
                  {{ service.status }}
                </span>
              </td>
              <td>
                <template v-if="service.credentials">
                  <small v-if="service.credentials.anyOf.length > 1" class="credentials-hint">
                    Escolha uma das opções:
                  </small>
                  <template v-for="(group, i) in service.credentials.anyOf">
                    <div v-if="i > 0" :key="`or-${i}`" class="credentials-or">ou</div>
                    <div :key="`g-${i}`" class="credentials-group">
                      <span v-for="(atom, j) in group" :key="j">
                        <span class="credentials-atom">{{ atom }}</span>
                        <span v-if="j < group.length - 1" class="credentials-and"> + </span>
                      </span>
                    </div>
                  </template>
                </template>
                <span v-else class="text-muted">-</span>
              </td>
              <td>
                <template v-if="service.metadata && service.metadata.labels">
                  <small v-for="([key, value]) in Object.entries(service.metadata.labels)" :key="key">
                    {{ key }}: <strong>{{ value }}</strong><br>
                  </small>
                </template>
                <span v-else class="text-muted">-</span>
              </td>
              <td>
                <button class="btn btn-outline btn-sm" @click="openDetails(service)">Ver</button>
              </td>
            </tr>
            <tr v-if="!filteredServices.length">
              <td colspan="8" class="text-center">Nenhum registro</td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>

    <Modal v-if="currentService" v-model="showModal" width="lg">
      <div slot="header">
        <h3>
          <strong>{{ currentService.metadata && currentService.metadata.title }}</strong>
          <small class="ml-2 mr-2 text-muted">{{ currentService.app }} / {{ currentService.name }}</small>
          <button v-if="format !== 'text'" class="btn btn-sm btn-outline float-right mr-2" @click="format = 'text'">Texto</button>
          <button v-if="format !== 'json'" class="btn btn-sm btn-outline float-right mr-2" @click="format = 'json'">JSON</button>
        </h3>
      </div>

      <Panel v-if="format === 'json'" :data="currentService" :deep="5"/>

      <div v-else class="row">
        <div class="col-md-12">
          <p v-if="currentService.metadata && currentService.metadata.description">
            {{ currentService.metadata.description }}
          </p>

          <p>
            <strong>Situação <span class="en-hint">(status)</span>:</strong>
            <span class="status-badge" :class="statusClass(currentService.status)">
              {{ currentService.status }}
            </span>
          </p>

          <div v-if="currentService.metadata && currentService.metadata.labels" class="mb-3">
            <strong>Rótulos <span class="en-hint">(labels)</span></strong>
            <ul class="mb-0">
              <li v-for="([key, value]) in Object.entries(currentService.metadata.labels)" :key="key">
                {{ key }}: <strong>{{ value }}</strong>
              </li>
            </ul>
          </div>

          <div class="mb-3">
            <strong>Credenciais <span class="en-hint">(credentials)</span></strong>
            <p v-if="!currentService.credentials" class="text-muted mb-0">Sem exigência de credenciais.</p>
            <template v-else>
              <p v-if="currentService.credentials.anyOf.length > 1" class="credentials-hint mb-2">
                Escolha <strong>uma</strong> das opções abaixo:
              </p>
              <p v-else class="credentials-hint mb-2">Credenciais exigidas:</p>
              <div class="credentials-options">
                <template v-for="(group, i) in currentService.credentials.anyOf">
                  <div v-if="i > 0" :key="`mor-${i}`" class="credentials-or-lg">ou</div>
                  <div :key="`mg-${i}`" class="credentials-group-box">
                    <span class="credentials-option-label">Opção {{ i + 1 }}</span>
                    <div class="credentials-atoms">
                      <span v-for="(atom, j) in group" :key="j">
                        <span class="credentials-atom-badge">{{ atom }}</span>
                        <span v-if="j < group.length - 1" class="credentials-and"> + </span>
                      </span>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>

          <div class="mb-3">
            <strong>Configurações do sistema <span class="en-hint">(system_settings)</span></strong>
            <p v-if="!currentService.systemSettings && !currentService.system_settings" class="text-muted mb-0">Nenhum.</p>
            <table v-else class="table table-sm">
              <thead>
                <tr>
                  <th>Nome <span class="en-hint">(name)</span></th>
                  <th>Tipo <span class="en-hint">(type)</span></th>
                  <th>Padrão <span class="en-hint">(default)</span></th>
                  <th>Descrição <span class="en-hint">(description)</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="([key, input]) in entriesOf(currentService.systemSettings || currentService.system_settings)"
                    :key="key">
                  <td>{{ key }}</td>
                  <td>{{ input.type }}</td>
                  <td>{{ input.default !== undefined ? input.default : '-' }}</td>
                  <td>{{ input.description || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mb-3">
            <strong>Configurações do cliente <span class="en-hint">(client_settings)</span></strong>
            <p v-if="!currentService.clientSettings && !currentService.client_settings" class="text-muted mb-0">Nenhum.</p>
            <table v-else class="table table-sm">
              <thead>
                <tr>
                  <th>Nome <span class="en-hint">(name)</span></th>
                  <th>Tipo <span class="en-hint">(type)</span></th>
                  <th>Opções <span class="en-hint">(options)</span></th>
                  <th>Descrição <span class="en-hint">(description)</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="([key, input]) in entriesOf(currentService.clientSettings || currentService.client_settings)"
                    :key="key">
                  <td>{{ key }}</td>
                  <td>{{ input.type }}</td>
                  <td>{{ describeInputOptions(input) }}</td>
                  <td>{{ input.description || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mb-3">
            <strong>Variantes <span class="en-hint">(variants)</span></strong>
            <p v-if="!currentService.variants || !currentService.variants.length" class="text-muted mb-0">
              Nenhuma.
            </p>
            <table v-else class="table table-sm">
              <thead>
                <tr>
                  <th>Nome <span class="en-hint">(name)</span></th>
                  <th>Valor <span class="en-hint">(value)</span></th>
                  <th>Descrição <span class="en-hint">(description)</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="variant in currentService.variants" :key="variant.value">
                  <td>{{ variant.name }}</td>
                  <td>{{ variant.value }}</td>
                  <td>{{ variant.description || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

      <div slot="footer">
        <button class="btn btn-outline" @click="showModal = false">Fechar</button>
      </div>
    </Modal>

  </div>
</template>

<script>
  import Modal from '@/components/shares/specialTag/Modal'
  import Panel from '@/components/admin/maestro/Panel'
  import GlobalLoading from '@/mixins/GlobalLoading'

  export default {
    components: { Modal, Panel },
    computed: {
      appOptions() {
        const apps = new Set(this.services.map(s => s.app).filter(Boolean))
        return [...apps].sort()
      },
      filteredServices() {
        const term = this.search.trim().toLowerCase()
        return this.services.filter(service => {
          if (this.filterApp && service.app !== this.filterApp) return false
          if (this.filterStatus && service.status !== this.filterStatus) return false
          if (!term) return true

          const title = (service.metadata && service.metadata.title) || ''
          const description = (service.metadata && service.metadata.description) || ''
          return [service.app, service.name, title, description]
            .some(value => String(value).toLowerCase().includes(term))
        })
      },
      infoTotalModels() {
        const total = this.filteredServices.length
        if (!total) return 'Nenhum registro'
        return `Mostrando ${total} de ${this.services.length} registro(s)`
      }
    },
    created() {
      this.loadServices()
    },
    data() {
      return {
        currentService: null,
        filterApp: '',
        filterStatus: '',
        format: 'text',
        search: '',
        services: [],
        showModal: false
      }
    },
    methods: {
      describeInputOptions(input) {
        if (!input) return '-'
        if (Array.isArray(input.enum)) return input.enum.join(', ')
        if (Array.isArray(input.range)) return `${input.range[0]} — ${input.range[1]}`
        if (input.min !== undefined || input.max !== undefined)
          return `min: ${input.min ?? '-'}, max: ${input.max ?? '-'}`
        return '-'
      },
      entriesOf(value) {
        return value ? Object.entries(value) : []
      },
      async loadServices() {
        try {
          this.openGlobalLoad()
          const response = await this.axios.v3.get('admin/template_services')
          this.services = response.data || []
        } catch (error) {
          this.$notify.addError('Erro ao carregar Template Services')
        } finally {
          this.closeGlobalLoad()
        }
      },
      openDetails(service) {
        this.currentService = service
        this.format = 'text'
        this.showModal = true
      },
      statusClass(status) {
        return {
          'status-active': status === 'active',
          'status-inactive': status === 'inactive',
          'status-maintenance': status === 'in_maintenance'
        }
      }
    },
    mixins: [GlobalLoading],
    name: 'TemplateServicesIndex'
  }
</script>

<style scoped>

  * {
    color: black;
  }

  .status-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    color: #fff !important;
    background: #888;
  }

  .status-active {
    background: #2e7d32;
  }

  .status-maintenance {
    background: #ef6c00;
  }

  .status-inactive {
    background: #6b6b6b;
  }

  .text-muted {
    color: #888;
  }

  .en-hint {
    color: #9a9a9a;
    font-weight: 400;
    font-size: 0.85em;
    font-style: italic;
    margin-left: 2px;
  }

  .credentials-hint {
    color: #666;
    font-style: italic;
    display: block;
    margin-bottom: 4px;
  }

  .credentials-group {
    padding: 2px 0;
  }

  .credentials-atom {
    display: inline-block;
    background: #e3f2fd;
    color: #0d47a1;
    padding: 1px 6px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 500;
  }

  .credentials-and {
    color: #2e7d32;
    font-weight: 600;
  }

  .credentials-or {
    color: #c62828;
    font-weight: 700;
    font-size: 11px;
    text-transform: uppercase;
    text-align: center;
    padding: 2px 0;
    letter-spacing: 1px;
  }

  .credentials-options {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .credentials-group-box {
    border: 1px solid #90caf9;
    border-radius: 6px;
    padding: 8px 12px;
    background: #f5fbff;
    min-width: 140px;
  }

  .credentials-option-label {
    display: block;
    font-size: 11px;
    font-weight: 700;
    color: #1565c0;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 4px;
  }

  .credentials-atoms {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px;
  }

  .credentials-atom-badge {
    display: inline-block;
    background: #1565c0;
    color: #fff !important;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }

  .credentials-or-lg {
    color: #c62828;
    font-weight: 700;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 2px;
    padding: 0 8px;
  }

</style>
